<template>
  <!-- 短信通知模板管理 -->
  <div class="recruit-container">
    <div class="page-title">短信通知管理</div>
    <el-button type="primary" class="new-add-button" @click="newAddAddress">新增短信通知</el-button>
    <el-table border :data="tableData" style="width:100%;overflow:auto;">
      <el-table-column prop="step" label="过程"></el-table-column>
      <el-table-column label="接收人">
        <template slot-scope="scope">
          <div
            class
            v-for="(item,index) in scope.row.template_receiver"
            :key="index"
          >{{index + 1}}.{{item.name}}-{{item.phone_numbers}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="action" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">更新</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page"
      :page-size="10"
      layout="total, prev, pager, next"
      :total="totalPage"
    ></el-pagination>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="info-value-box">
        <div class="info-title">
          <span>*</span>过程：
        </div>
        <el-select v-model="addInfo.step" placeholder="请选择">
          <el-option v-for="(item,index) in stepList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
        <!-- <el-input placeholder="请输入" v-model="addInfo.step"></el-input> -->
      </div>
      <!-- <div class="info-value-box">
        <div class="info-title">
          <span>*</span>模板Code：
        </div>
        <el-input placeholder="请输入" v-model="addInfo.template_code"></el-input>
      </div>-->
      <el-button size="mini" class="add-button" type="primary" @click="addPeople">新增接收人</el-button>
      <div v-for="(item,index) in template_receiver" :key="index">
        <div class="info-value-box">
          <div class="info-title">接收人：</div>
          <el-input class="p-list" placeholder="请输入姓名" v-model="item.name"></el-input>
          <el-input class="p-list" placeholder="请输入手机号" v-model="item.phone_numbers"></el-input>
          <el-button size="mini" type="danger" @click="deletePeople(index)">删除</el-button>
        </div>
      </div>

      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="confirmAdd">确 定</el-button>
    </el-dialog>
    <el-dialog title="删除" :close-on-click-modal="false" :visible.sync="deleteVisible" width="30%">
      <div class="delete-text">确认删除吗？</div>
      <el-button @click="deleteVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmDelete">确 定</el-button>
    </el-dialog>
  </div>
</template>
<script>
import api from '../api/api';
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      deleteVisible: false,
      tableData: [],
      totalPage: 0,
      page: 1,
      deleteId: '',
      dialogTitle: '新增',
      addInfo: {
        step: ''
      },

      template_receiver: [
        {
          name: '',
          phone_numbers: ''
        }
      ],
      stepList: [
        '销售修改预通知单提醒仓库',
        '销售完成预通知单提醒仓库',
        '出货单制作完成',
        '仓库出货完成',
        '仓库备货后提醒销售助理'
      ]
    };
  },

  mounted() {
    this.getMessage();
  },
  methods: {
    deletePeople(index) {
      this.template_receiver.splice(index, 1);
    },
    addPeople() {
      const obj = {
        name: '',
        phone_numbers: '',
        template_id: this.updateId
      };
      this.template_receiver.push(obj);
    },
    getMessage() {
      const params = {
        page: this.page,
        pageSize: 10
      };
      api.getMessage(params).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.tableData = result.data.list;
          this.totalPage = result.data.total;
        } else {
          this.$message.warning(result.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getMessage();
    },
    handleDelete(item) {
      this.deleteVisible = true;
      this.deleteId = item.id;
    },
    // 新增
    newAddAddress() {
      this.dialogVisible = true;
      this.dialogTitle = '新增';
    },
    // 确认新增
    confirmAdd() {
      if (!this.addInfo.step) {
        this.$message.warning('请选择过程！');
      } else {
        let params = {
          step: this.addInfo.step,
          template_receiver: this.template_receiver
        };
        if (this.dialogTitle === '新增') {
          api.addMessage(params).then(res => {
            const result = res.data;
            if (result.code === 0) {
              this.dialogVisible = false;
              this.getMessage();
              this.email = '';
              this.email_type = '';
              this.comment = '';
              this.$message.success('新增成功！');
            } else {
              this.$message.error(result.msg);
            }
          });
        } else {
          params.id = this.updateId;
          api.editMessage(params).then(res => {
            const result = res.data;
            if (result.code === 0) {
              this.dialogVisible = false;
              this.getMessage();
              this.email = '';
              this.email_type = '';
              this.comment = '';
              this.$message.success('更新成功！');
            } else {
              this.$message.error(result.msg);
            }
          });
        }
      }
    },
    cancel() {
      this.getMessage();
      this.dialogVisible = false;
    },
    // 更新
    handleUpdate(item) {
      this.updateId = item.id;
      this.template_receiver = item.template_receiver;
      this.addInfo.step = item.step;
      this.dialogTitle = '更新';
      this.dialogVisible = true;
    },
    // 确认删除
    confirmDelete() {
      api.deleteMessage({ id: this.deleteId }).then(res => {
        const result = res.data;
        if (result.code === 0) {
          this.$message.success('删除成功！');
          this.deleteVisible = false;
          this.getMessage();
        } else {
          this.$message.error(result.error);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.recruit-container {
  position: relative;
  flex: 1;
  padding: 32px;
  overflow: auto;
  .page-title {
    flex: 1;
    padding-bottom: 20px;
    font-size: 24px;
  }
  .table-img {
    cursor: pointer;
  }
  .new-add-button {
    position: absolute;
    top: 32px;
    right: 32px;
    height: 30px;
    padding: 0 20px;
    line-height: 30px;
  }
  .add-button {
    display: block;
    margin-bottom: 10px;
  }
  .img-style {
    display: block;
    height: 300px;
    margin: 0 auto;
  }
  .p-list {
    margin-right: 10px;
  }
  .address-input {
    margin-bottom: 30px;
  }
  .delete-text {
    padding-bottom: 30px;
  }
  /deep/ .el-dialog__body {
    overflow: auto;
  }
  /deep/ .el-input,
  .el-select {
    flex: 1;
  }
  /deep/ .el-pagination {
    padding-top: 20px;
    text-align: right;
    .number,
    .el-pagination__total {
      font-size: 18px;
    }
  }
  .info-value-box {
    display: flex;
    align-items: center;
    padding-bottom: 30px;
  }
  .info-title {
    width: 94px;
    padding-bottom: 10px;
    font-size: 16px;
    span {
      color: crimson;
    }
  }
  .address-box {
    width: 20%;
    margin-bottom: 30px;
    border: 1px solid #eee;
  }
  .address-list {
    display: flex;
    padding: 10px 10px 10px 0;
    align-items: center;
    .list-name {
      flex: 1;
      padding: 0 20px;
    }
  }
}
.more-text {
  padding: 0 20px;
  font-size: 16px;
  color: #409eff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/message.vue